module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "section-header"
  }, [_vm._v("Select Field Types")]), _vm._v(" "), _c('ed-select', {
    attrs: {
      "options": _vm.options1,
      "field-label": "Single Select, Required",
      "required": ""
    }
  }), _vm._v(" "), _c('ed-select', {
    attrs: {
      "options": _vm.options2,
      "field-label": "Single Select, Required, With Helptip",
      "helptipBody": "This is a helptip, letting you know what to do.",
      "required": ""
    }
  }), _vm._v(" "), _c('ed-select', {
    attrs: {
      "options": _vm.options3,
      "label": "title",
      "track-by": "title",
      "field-label": "Sinlge Select, With Images",
      "helptipBody": "This is a helptip, letting you know what to do.",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('ed-select-options', {
          attrs: {
            "thumbnails": ""
          }
        }, [_c('img', {
          attrs: {
            "slot": "image",
            "src": props.option.img
          },
          slot: "image"
        }), _vm._v(" "), _c('p', {
          attrs: {
            "slot": "row1"
          },
          slot: "row1"
        }, [_vm._v(_vm._s(props.option.title) + " (" + _vm._s(props.option.number) + ")")]), _vm._v(" "), _c('p', {
          attrs: {
            "slot": "row2"
          },
          slot: "row2"
        }, [_vm._v(_vm._s(props.option.tags))])])]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('ed-select', {
    attrs: {
      "options": _vm.options4,
      "label": "full_name",
      "track-by": "full_name",
      "field-label": "Content Select, No Images"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('ed-select-options', [_c('p', {
          attrs: {
            "slot": "row1"
          },
          slot: "row1"
        }, [_vm._v(_vm._s(props.option.full_name))]), _vm._v(" "), _c('p', {
          attrs: {
            "slot": "row2"
          },
          slot: "row2"
        }, [_vm._v(_vm._s(props.option.email))])])]
      }
    }])
  }), _vm._v(" "), _c('ed-select', {
    attrs: {
      "options": _vm.options5,
      "label": "full_name",
      "track-by": "full_name",
      "field-label": "Content Select, No Images, More Data"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('ed-select-options', [_c('p', {
          attrs: {
            "slot": "row1"
          },
          slot: "row1"
        }, [_vm._v(_vm._s(props.option.full_name))]), _vm._v(" "), _c('p', {
          attrs: {
            "slot": "row2"
          },
          slot: "row2"
        }, [_vm._v(_vm._s(props.option.email))]), _vm._v(" "), _c('p', {
          attrs: {
            "slot": "row3"
          },
          slot: "row3"
        }, [_vm._v("O: " + _vm._s(props.option.office))]), _vm._v(" "), _c('p', {
          attrs: {
            "slot": "row4"
          },
          slot: "row4"
        }, [_vm._v("C: " + _vm._s(props.option.cell))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ed-button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.showModal1 = true
      }
    }
  }, [_vm._v("Launch Modal 1")]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "show": _vm.showModal1,
      "title": "Budget Information",
      "subtitle": "Tell us about your budget."
    },
    on: {
      "close": function($event) {
        _vm.showModal1 = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('program-list', {
    attrs: {
      "legacy": "true"
    }
  })], 1)])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticClass: "section-header"
  }, [_vm._v("Tab Nav Demo")]), _vm._v(" "), _c('ed-tab-nav', {
    staticClass: "uniform",
    attrs: {
      "workflow": ""
    }
  }, [_c('ed-tab', {
    attrs: {
      "title": "Completed Agenda",
      "completed": true,
      "icon": ['fal', 'list-alt']
    }
  }, [_c('project-agenda')], 1), _vm._v(" "), _c('ed-tab', {
    attrs: {
      "title": "Project Information",
      "active": true,
      "icon": ['fal', 'clipboard']
    }
  }, [_c('project-information')], 1), _vm._v(" "), _c('ed-tab', {
    attrs: {
      "title": "Clients",
      "completed": true,
      "icon": ['fal', 'address-book']
    }
  }, [_c('project-clients')], 1), _vm._v(" "), _c('ed-tab', {
    attrs: {
      "title": "Services",
      "icon": ['fal', 'shopping-basket']
    }
  }, [_c('project-services')], 1), _vm._v(" "), _c('ed-tab', {
    attrs: {
      "title": "Design & Layout",
      "icon": ['fal', 'paint-brush']
    }
  }, [_c('project-design')], 1), _vm._v(" "), _c('ed-tab', {
    attrs: {
      "title": "Project Settings",
      "icon": ['fal', 'rocket']
    }
  }, [_c('project-settings')], 1)], 1)], 1)]), _vm._v(" "), _vm._m(3)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Select Field \n          "), _c('span', {
    staticClass: "component-name"
  }, [_vm._v("<ed-select />")])]), _vm._v(" "), _c('p', {
    staticClass: "component-description"
  }, [_vm._v("The <ed-select /> tag specifies a select field.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticClass: "section-header"
  }, [_vm._v("Select Field Code")]), _vm._v(" "), _c('pre', [_vm._v("              "), _c('code', [_vm._v("\n                Code Example Here\n              ")]), _vm._v("\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Tab Nav\n          "), _c('span', {
    staticClass: "component-name"
  }, [_vm._v("<ed-tab-nav />")])]), _vm._v(" "), _c('p', {
    staticClass: "component-description"
  }, [_vm._v("The <ed-tab-nav /> tag adds a slick tab nav.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticClass: "section-header"
  }, [_vm._v("Tab Nav Code")]), _vm._v(" "), _c('pre', [_vm._v("                "), _c('code', [_vm._v("\n                  Code Example Here\n                ")]), _vm._v("\n              ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13fb5dcf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectField.vue
// module id = sFzz
// module chunks = 13 14